export class Login {
    organizationId: string
    userId: string
    password: string
}



// WEBPACK FOOTER //
// ./src/models/login.ts